import React, { FunctionComponent, useState, useEffect } from 'react';
import { toast, Zoom } from 'react-toastify';
import { Snackbar } from '../Snackbar/Snackbar';
import { IActionTrackingProps,IEmailRemarkModel } from './IActionTrackingProps';
import { EmailTargetComponent } from './EmailTargetComponent';
import {  DELETERECORD_MESSAGE, PROPOSED_ACTION_TRACKING_STATUS} from '../../constants/constants';
import './ActionTracking.scss';


export const ActionTracking: FunctionComponent<IActionTrackingProps> = (props) => {
   const [emailRemark, setEmailRemark] = useState([] as any);
 const [sameDatePostion,setSameDatePosition]=useState([] as any);
        const isTrainingRequiredReason = props.actionType === 'acceptanddropdown';
   useEffect(() => {
    // For the model-304 proposed-tracking flow, wait until the proposed data has actually
    // finished loading before initializing rows, otherwise a blank row gets created first
    // and the real data (arriving a moment later) never gets applied.
    if (props.isProposedTrackingFlow && !props.proposedDataReady) {
        return;
    }
    if(props.isChecked===true && emailRemark.length === 0){
        let temp = [...emailRemark];
        const proposed = (props.proposedActionTracking || []).filter((item: any) => item.reason_id === props.reasonId);
        if (proposed.length > 0) {
            proposed.forEach((item: any) => {
                temp.push({
                    action_owner_id: item.user_id,
                    action_owner_email: item.email,
                    target_date: item.target_date ? new Date(item.target_date).toDateString() : "",
                    remarks: item.remarks || "",
                    training_name: item.training_name,
                    // Pre-checks the "already completed" checkbox when the reviewer proposed it as such
                    isActionTaken: item.status === PROPOSED_ACTION_TRACKING_STATUS.PROPOSED_COMPLETED,
                    isValid: Boolean(item.email && item.target_date && (item.remarks || !props.isCommentRequired)),
                    createdOn: new Date().getTime().toString()
                });
            });
        } else {
            temp.push({ action_owner_id: "", target_date: "", remarks: "", training_name: "", isValid: false, createdOn: new Date().getTime().toString() });
        }
        setEmailRemark(temp);
        const shareToValueElement={
            reason_id:props.reasonId,
            reason:props.reasonTitle,
            data:temp
        }
        props.onAddedActionEmail(shareToValueElement, temp.every((item: any) => item.isValid));
    }
}, [props.isChecked, props.proposedDataReady, props.proposedActionTracking?.length, props.reasonId]);


const onAddElement = () => {
        const emailRemarkValue = [...emailRemark];
        emailRemarkValue.push({ action_owner_id: "", target_date: "", remarks: "", training_name: "", isValid:false,createdOn: new Date().getTime().toString() })
        setEmailRemark(emailRemarkValue);
        const shareToValueElement={
            reason_id:props.reasonId,
            reason:props.reasonTitle,
            data:emailRemarkValue
        }
        props.onAddedActionEmail(shareToValueElement,false);
    }


    const onDeleteElement = ( elementPositionValue: number) => {
        let emailRemarkValue=[...emailRemark];
        emailRemarkValue.splice(elementPositionValue, 1);
        let isValid=false;
        const isInValidArray=emailRemarkValue.filter((item:any)=>{
            return(
                item.isValid===false
            )
        })
        if(isInValidArray.length===0){
            isValid=true;
        }
        const shareToValueElement={
            reason_id:props.reasonId,
            reason:props.reasonTitle,
            data:emailRemarkValue
        }
            
        props.onAddedActionEmail(shareToValueElement,isValid);
        setEmailRemark([...emailRemarkValue]);

    }
    const  handleModifyDataofArray=(dataValue:string,postion:number,propertyType:string,isValid:boolean)=>{
        const emailRemarkValue = [...emailRemark];

        if(propertyType==="target_date"){
        let emailRemarkValueFOrDate=[...emailRemark]
            emailRemarkValueFOrDate.splice(postion, 1);

           let duplicateEmailValue= emailRemarkValueFOrDate.filter((item:IEmailRemarkModel)=>{return( 
                item.action_owner_id=== emailRemarkValue[postion].action_owner_id)
            })
            let duplicateEmailAndDateValue=[];
            if(duplicateEmailValue&&duplicateEmailValue.length>0){
                
                 duplicateEmailAndDateValue= duplicateEmailValue.filter((item:any)=>{return( 
                    item.target_date=== dataValue)
                })
                
               if( duplicateEmailAndDateValue&&duplicateEmailAndDateValue.length>0){
                     emailRemarkValue[postion][propertyType]="";
                     emailRemarkValue[postion]["createdOn"]= new Date().getTime().toString();
                     emailRemarkValue[postion]["isValid"]=false;
                     toast(<Snackbar toastMessage={DELETERECORD_MESSAGE} />, {
                        position: 'top-right',
                        className: 'fi-toast--snackbar',
                        bodyClassName: 'fi-toast__body--snackbar',
                        transition: Zoom,
                        closeOnClick: true,
                      });
                      let sameDate=[...sameDatePostion];
                      sameDate.push(postion);
                      setSameDatePosition(sameDate);
                 
            setEmailRemark(emailRemarkValue);
               }
            }
            if(duplicateEmailAndDateValue.length===0){
                emailRemarkValue[postion][propertyType]=dataValue;
                emailRemarkValue[postion]["isValid"]=isValid;

                setEmailRemark(emailRemarkValue);
            }
          
        
        }else 
        {
            emailRemarkValue[postion][propertyType]=dataValue;
            emailRemarkValue[postion]["isValid"]=isValid;
            setEmailRemark(emailRemarkValue);
        }
        const isValidActionReason=emailRemarkValue.filter((item:IEmailRemarkModel)=>{return(item.isValid===false)})
        const isValidActionReasonStatus=isValidActionReason.length===0;
        const shareToValueElement={
            reason_id:props.reasonId,
            reason:props.reasonTitle,
            data:emailRemarkValue,
        }
        props.onAddedActionEmail(shareToValueElement,isValidActionReasonStatus);
    }


    return (
        <div>
            {emailRemark.map((item: IEmailRemarkModel, index: any) => {
                return (<EmailTargetComponent
                     key={item.createdOn}
                    elementPosition={index}
                    email={item.action_owner_email}
                    remark={item.remarks}
                    date={item.target_date}
                    onAddElement={onAddElement}
                    onDeleteElement={onDeleteElement}
                    emailRemarkLength={emailRemark.length} 
                    handleModifyDataofArray={handleModifyDataofArray}
                    isRemarkRequired={props.isCommentRequired}
                    reasonId={props.reasonId}
                    actionType={props.actionType}
                    sameDatePostion={sameDatePostion}
                    trainingOptions={isTrainingRequiredReason ? props.trainingOptions : []}
                    trainingName={item.training_name}
                    isActionTaken={item.isActionTaken}
                    hideRowControls={props.hideRowControls}
                    />
                );
            })
            }
        </div>
    )
};